/**
 * Добавляет макротаску на открытие страницы в этом же окне,
 * для предотвращения прерывания отправки событий
 */
export var navigateToPage = function navigateToPage(url) {
  return setTimeout(function () {
    return window.location.assign(url);
  });
};